/** 小票打印机预设（各店铺从下拉选择即可） */
export type PosPrinterOption = {
  label: string;
  value: string;
  port: string;
  /** 机身序列号，仅作备份记录，连接时不使用 */
  serialNo?: string;
};

/**
 * 已知打印机默认列表。
 * 本地 JSON 能解析出非空列表时用本地的，否则用此默认配置。
 */
export const POS_PRINTER_PRESET_LIST: PosPrinterOption[] = [
  {
    label: '銀座一階',
    value: 'epsona4182c.local',
    port: '8043',
    serialNo: 'XBVK001804',
  },
  {
    label: '梅田',
    value: 'epsona92f89.local',
    port: '8043',
    serialNo: 'XBVK010095',
  },
  {
    label: '迪拜',
    value: 'epsona53347.local',
    port: '8043',
  },
  {
    label: '新加坡',
    value: 'epsona60be3.local',
    port: '8043',
  },
];
